import { useHistory } from 'react-router-dom';
import React, { useCallback, useMemo } from 'react';
import { match } from 'path-to-regexp';
import { BotBuilderRoutes } from '../../../../../../../routes/bot-builder-routes';
import { useSelector } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import { selectCampaignById } from '@mm/state/selectors/campaignSelectors';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { useInputTriggerCRUD } from './use-input-trigger-crud';
import {
  getCampaignInputTriggerAudienceId,
  TAutomationInputTriggerType,
} from './use-input-triggers-identification';
import {
  errorToast,
  successToast,
} from '../../../../../../../common/helpers/toast';

export const useDeleteAutomationTrigger = () => {
  const history = useHistory();

  const automation = useMemo(() => {
    return match<{ id?: string }>(BotBuilderRoutes.automationEdit.path)(
      history.location.pathname,
    ) as { params?: { id?: string } };
  }, [history.location.pathname]);
  const automationId = automation?.params?.id;

  const campaign = useSelector((state: StoreState) =>
    selectCampaignById(state, Number(automationId)),
  )!;

  const inputTriggerCRUD = useInputTriggerCRUD();

  const modalActions = useModalActions();

  const handleDelete = useCallback(
    (type: TAutomationInputTriggerType, id: number, name: string) => {
      if (!campaign) {
        return errorToast('Something went wrong', 'top-left');
      }

      return new Promise((resolve, reject) => {
        modalActions.openNewConfirmModal({
          image: <></>,
          title: `Are you sure you want to delete this ${name}?`,
          onReject: async () => reject(),
          resolveButton: {
            color: 'red',
            children: 'Delete',
            onClick: async () => {
              const audienceId = getCampaignInputTriggerAudienceId(
                campaign,
                type,
                id,
              );

              if (audienceId) {
                try {
                  await inputTriggerCRUD.removeTriggerFromAutomation({
                    campaign,
                    audienceId,
                  });

                  modalActions.closeModal();
                  resolve('');
                  successToast('Success', 'top-left');
                } catch (err) {
                  errorToast('Something went wrong', 'top-left');
                }
              }
            },
          },
        });
      });
    },
    [],
  );

  return {
    automationId,
    handleDelete,
  };
};
